<div class="confirmation-ensemble">
  <p class="confirmation-ensemble__title">
    <i *ngIf="data.messageType === ConfirmationMessageType.INFO"
       class="fas fa-question-circle confirmation-ensemble__icon confirmation-ensemble__icon--info"
       aria-hidden="true"></i>
    <i *ngIf="data.messageType === ConfirmationMessageType.WARNING"
       class="fas fa-exclamation-triangle confirmation-ensemble__icon confirmation-ensemble__icon--warning"
       aria-hidden="true"></i>
    {{ data.messageTitle }}
  </p>
  <p *ngIf="data.message" class="confirmation-ensemble__message">{{ data.message }}</p>
</div>

<div slot="footer" class="d-flex">
  <div class="flex-spacer"></div>
  <en-btn size="sm" type="button" (click)="confirm()">{{ data.confirmButtonLabel || 'OK' }}</en-btn>
</div>
